import ApiClient from './ApiClient';

class WinkerSsoAPI extends ApiClient {
  constructor() {
    super('winker_sso', { accountScoped: true });
  }
}

export default new WinkerSsoAPI();
